function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 7,
  width: 2,
  height: 10,
  rx: 1,
  fill: "#333"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 7,
  width: 2,
  height: 10,
  rx: 1,
  fill: "#333"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 7,
  width: 2,
  height: 10,
  rx: 1,
  fill: "#333"
});

function SvgSliderThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNyIgeT0iNyIgd2lkdGg9IjIiIGhlaWdodD0iMTAiIHJ4PSIxIiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjExIiB5PSI3IiB3aWR0aD0iMiIgaGVpZ2h0PSIxMCIgcng9IjEiIGZpbGw9IiMzMzMzMzMiLz4KPHJlY3QgeD0iMTUiIHk9IjciIHdpZHRoPSIyIiBoZWlnaHQ9IjEwIiByeD0iMSIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";
export { SvgSliderThumb as ReactComponent };